import { PageHero } from "../components/site/PageHero";

const CONTENT = {
  "privacy-policy": {
    title: "Privacy Policy",
    label: "Legal",
    blocks: [
      ["Overview", "This Privacy Policy explains how MATRIVON collects, uses and protects information provided through matrivon.com. By using this website you agree to the practices described here."],
      ["Information We Collect", "We collect information you voluntarily provide through our contact form (name, company, business email, country, area of interest and message) and newsletter signup (email address). We may also collect anonymous usage analytics to understand which content is useful."],
      ["How We Use Information", "Enquiry information is used solely to respond to your request and to provide relevant advisory follow-up. Newsletter emails are used to send MATRIVON Insights and related updates. We do not sell your personal data."],
      ["Data Retention & Security", "We retain enquiry and subscription data only as long as necessary for the purposes described, and apply reasonable measures to protect it."],
      ["Your Rights", "You may request access to, correction of, or deletion of your personal data at any time by contacting sonmez@matrivon.com."],
      ["Contact", "For any privacy question, contact sonmez@matrivon.com."],
    ],
  },
  "terms-of-use": {
    title: "Terms of Use",
    label: "Legal",
    blocks: [
      ["Acceptance", "By accessing matrivon.com you agree to these Terms of Use. If you do not agree, please do not use the website."],
      ["Use of Content", "All content on this website, including articles, calculators and resources, is provided for general information and educational purposes. It does not constitute professional, engineering, legal or investment advice."],
      ["No Warranty", "MATRIVON content and tools are provided 'as is' without warranties of any kind. While we aim for accuracy, we make no guarantee that content is current, complete or error-free."],
      ["Limitation of Liability", "MATRIVON is not liable for any loss or damage arising from reliance on website content, calculators or resources. Decisions taken remain the responsibility of the user."],
      ["Intellectual Property", "MATRIVON branding and original content may not be reproduced without permission."],
      ["Contact", "Questions regarding these terms can be directed to sonmez@matrivon.com."],
    ],
  },
  "technical-disclaimer": {
    title: "Technical Disclaimer",
    label: "Legal",
    blocks: [
      ["Educational Purpose", "MATRIVON technical content and calculators are educational and analytical tools only."],
      ["Not a Substitute", "They are not a substitute for laboratory validation, production trials, supplier technical data, SDS review, regulatory compliance or qualified engineering judgement."],
      ["Formulation Reality", "Formulation performance depends on actual raw-material specifications and process conditions. Calculator outputs are theoretical and must be verified against real materials and processes."],
      ["No Liability", "MATRIVON accepts no liability for outcomes arising from the use of technical content or calculators. Always consult qualified professionals and current supplier documentation before acting."],
    ],
  },
  "affiliate-disclosure": {
    title: "Affiliate Disclosure",
    label: "Legal",
    blocks: [
      ["Transparency", "Some pages on matrivon.com, primarily within Resources and selected Insights, may contain affiliate links. If you click such a link and make a purchase, MATRIVON may earn a commission at no additional cost to you."],
      ["Independence", "Recommendations and assessments are made independently of affiliate availability. A tool's inclusion or assessment is never influenced by whether an affiliate arrangement exists."],
      ["Link Attributes", "Affiliate links are marked appropriately and use rel=\"sponsored noopener\" attributes in line with best practice."],
      ["Credibility First", "MATRIVON's priority is credibility. Affiliate revenue is secondary to providing genuinely useful, independent assessments."],
      ["Contact", "Questions about our affiliate practices can be directed to sonmez@matrivon.com."],
    ],
  },
};

export default function Legal({ page }) {
  const c = CONTENT[page];
  if (!c) return null;
  return (
    <div>
      <PageHero variant="light" label={c.label} title={c.title} crumbs={[{ label: c.title }]} />
      <div className="mx-auto max-w-3xl px-5 py-16 lg:px-8">
        <div className="space-y-8">
          {c.blocks.map(([h, p]) => (
            <div key={h}>
              <h2 className="font-heading text-xl font-bold text-brand-ink">{h}</h2>
              <p className="mt-2 text-[16px] leading-relaxed text-brand-ink/80">{p}</p>
            </div>
          ))}
          <p className="border-t border-brand-line pt-6 text-sm text-brand-muted">
            Last updated: June 2026
          </p>
        </div>
      </div>
    </div>
  );
}
